import { ref } from 'vue';
import { guidUtil } from '@/utils';
import KeysService from './service';

const verificarLiberacaoViewModel = ref({
  validadeInicial: '',
  validadeFinal: '',
  ideLiberacao: guidUtil.empty,
  tipoSerial: '',
  cnpj: '',
  diasRestante: 0,
  valideInicialFormatted: '',
  valideFinalFormatted: '',
});

const serialPrincipal = ref();
const diasLiberacao = ref();
const liberarMaisTarde = ref();
const sistemaLiberadoDias = ref();

export { KeysService, verificarLiberacaoViewModel, serialPrincipal, diasLiberacao, liberarMaisTarde, sistemaLiberadoDias };
